import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import MDBox from "components/MDBox";
import { FormTitle, Text, SelectFields } from "ui-components/Form";
import { getCustomerOptions } from "services/data.internal.service";
import { useCustomerValue } from "providers/CustomerContext";

function DivisionInfo({ formRender, control, errors, mode = "ADD" }) {
  const [customerOptions, setCustomerOptions] = useState([]);
  const { customerCode, customerOpt } = useCustomerValue();

  useEffect(() => {
    const fetchCustomerOptions = async () => {
      try {
        const response = await getCustomerOptions({ customerCode });
        const activeCust = customerOpt.filter((x) => response.data.some((y) => y === x));
        setCustomerOptions(activeCust);
      } catch (err) {
        console.error("Error fetching customer options:", err);
        setCustomerOptions([]);
      }
    };

    fetchCustomerOptions();
  }, [customerCode, customerOpt]);

  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Division" : "Division Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...fieldProps } = property;
              const commonProps = {
                ...fieldProps,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              let renderField = null;

              switch (fieldProps.type) {
                case "text":
                  renderField = <Text field={commonProps} />;
                  break;

                case "select":
                  if (fieldProps.name === "customerCode") {
                    renderField = (
                      <Controller
                        control={control}
                        name="customerCode"
                        rules={{ required: "Customer is Required" }}
                        render={({ field, fieldState: { error } }) => (
                          <SelectFields
                            field={{
                              ...field,
                              label: (
                                <span>
                                  <span style={{ color: "red" }}> Customers *</span>
                                </span>
                              ),
                              value: field.value ?? [],
                              multiple: true,
                              errors,
                              error: !!error,
                              helperText: error?.message,
                            }}
                            options={customerOptions}
                            onChange={(e, value) => field.onChange(value)}
                          />
                        )}
                      />
                    );
                  }
                  break;

                default:
                  break;
              }

              return (
                <Grid item xs={12} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default DivisionInfo;